import type { TLanguageCode } from '@docue/builder-intl'
import type { TSupportedLocale } from '@docue/builder/i18n'

import { BROWSER_SESSION } from '~/types'

import { useInternalApi, type WithOptions } from '../useInternalApi'

export type TemplateData = App.Http.InternalApi.BrowsingSession.Data.Template.TemplateData

// TODO payload from eb-types (when available)
export interface TemplateAllPayload {
  params: {
    page: number
    per_page: number
    'filter[collection]'?: string
    'filter[query]'?: string
    'filter[language]'?: TLanguageCode
    sort?: 'title' | 'id' | 'updated_at'
    sort_locale?: TSupportedLocale
  }
}

export const useFetchTemplate = () => {
  const { get, getMany, getUrl } = useInternalApi()

  const getById = ({
    id,
    options,
  }: WithOptions<{ id: string }>) =>
    get<TemplateData>({
      url: getUrl(BROWSER_SESSION, `templates/${id}`),
      accessType: BROWSER_SESSION,
      options: {
        params: {
          include: 'languages,jurisdictions',
        },
        ...options,
      },
    }).then(res => res.data)

  const getAll = ({
    payload: { params },
    options,
  }: WithOptions<{
    payload: TemplateAllPayload
  }>) =>
    getMany<TemplateData[]>({
      url: getUrl(BROWSER_SESSION, 'templates'),
      accessType: BROWSER_SESSION,
      options: {
        params: {
          include: 'languages,jurisdictions',
          ...params,
        },
        ...options,
      },
    })

  return {
    getById,
    getAll,
  }
}
